import React, { useState, useEffect } from "react";
import { Col, Row, Modal, ModalBody, Input, Label, Form } from "reactstrap";
import { Container} from "reactstrap";
import { Link } from "react-router-dom";
import { AppConfiguration } from "read-appsettings-json";
import { GetRequest, PostRequest } from '../../../noser-dataaccess'
import axios from 'axios'

//Job Images
import jobImage1 from "../../../assets/images/featured-job/img-01.png";
import jobImage2 from "../../../assets/images/featured-job/img-02.png";
import jobImage3 from "../../../assets/images/featured-job/img-03.png";
import jobImage4 from "../../../assets/images/featured-job/img-04.png";
import { useNavigate } from "react-router-dom";
import { Typeahead } from 'react-bootstrap-typeahead';
import "react-bootstrap-typeahead/css/Typeahead.css";

const JobVacancy = () => {
  // Navigate to another screen 
  const navigate = useNavigate();
  const navigateApp = useNavigate();
  const navigateEmployer = useNavigate();

  //Apply Now Model
  const [modal, setModal] = useState(false);
  const openModal = () => setModal(!modal);
  const [jobVacancy, setJobVacancy] = useState([]);
  const [storeJson, setStoreJson] = useState([]);
  const [compProfile, setJson] = useState([]);
  
  const [jobVacancyDDL, setJobVacancyDDL] = useState([]);
  const [compNameDDL, setCompNameDDL] = useState([]);
  const [jobTypeDDL, setJobTypeDDL] = useState([]);
  const [jobDept, setJobDeptDDL] = useState([]);
  const [validate, setValidate] = useState("");
  const [isHide, setOnhide] = useState(false);
  
  const [srchCompName, setCompName] = useState("");
  const [srchLocation, setLocation] = useState("");
  const [srchJobClass, setJobClass] = useState("");
  const [srchPosition, setPosition] = useState("");

  // Currently selected job for the right-hand detail pane (two-pane layout)
  const [selectedJob, setSelectedJob] = useState(null);

  // Keep a job selected: default to the first result and re-sync when the list changes
  useEffect(() => {
    if (jobVacancy && jobVacancy.length > 0) {
      setSelectedJob((prev) =>
        prev && jobVacancy.some((j) => j.postingId === prev.postingId)
          ? prev
          : jobVacancy[0]
      );
    } else {
      setSelectedJob(null);
    }
  }, [jobVacancy]);

  // Pull a display string out of a list item that may be a string or an object
  const itemText = (itm, keys) => {
    if (itm === null || typeof itm === "undefined") return "";
    if (typeof itm === "string") return itm;
    for (const k of keys) {
      if (itm[k]) return itm[k];
    }
    return "";
  };

  useEffect(() => {

    const isValidate = JSON.parse(sessionStorage.getItem("userCollection"))
    if (isValidate === null){

      setValidate("0")
      
    }
    else {

      if(isValidate[0].isEmployer === "1"){

        setValidate("1")

      }
      else {

        setValidate("0")

      }
    }
    GetCompanyProfile()

  }, []);

  const GetCompanyProfile = async() => {

    let filter_data = {"isDeleted": "0"}
    const dataTmp = []

    // // // console.log("1")
    const Params = {

      // "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
      "_collection" : "CompanyProfile",
      "filter_data" : filter_data

    }
    // // // console.log("2")
    axios
    .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
    .then(res => {

      // // // console.log("3")
      let data = res.data

      // // // // console.log("data company prof")
      // // // // console.log(data.CompanyProfile)

      data.CompanyProfile.map(function(itm,i){

        const strJson = itm.replace("","").replace("ObjectId(","").replace(")","").replace("_","")
        const json = JSON.parse(strJson.replace(/'/g,'"'));
        dataTmp.push(json)
        // // // // console.log("json")
        // // // // console.log(json) 

      })   

      // console.log("CompanyProfile")
      // console.log(dataTmp)  

      setJson(dataTmp)  
      GetDataJobposting(dataTmp); 

    })
  };


  const GetDataJobposting =async(_dataList)=> {

    let dataListTmp = []

    try{

      let resp = await GetRequest({
        
        url : AppConfiguration.Setting().jobspaceapi + "action/get",
        params : {

          "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
          "_collection" : "JobPosting",
          "filter_data" : {}

        }

      })


        // console.log("resp.JobPosting")
        // console.log(resp.JobPosting)

      if(resp.status==="1"){

        // setCompanyId(companyProfList[0].id)
        resp.JobPosting.forEach((itm,idx)=> {

          // // console.log("itm")
          // // console.log(itm)

          // // // // // console.log("_dataList.filter(x=> x.userId===itm.companyId)")
          // // // // // console.log(_dataList.filter(x=> x.userId===itm.companyId))

          let expTmp = itm.experienceMin + " " + "-" + " " + itm.experienceMax

          // let locCity =   _dataList.filter(x=> x.userId===itm.companyId).length>0 ?
          //                 _dataList.find(x=> x.userId===itm.companyId).locationCity: ""
          // let locPrvnce = _dataList.filter(x=> x.userId===itm.companyId).length>0 ?
          //                 _dataList.find(x=> x.userId===itm.companyId).locationProvince: ""

          let sal1 = String(itm.salaryMin).replaceAll(',','')
          let sal2 = String(itm.salaryMax).replaceAll(',','')

          let _salaryRangeTmp = toTitleCase(itm.salaryCurrency) + " " + parseFloat(sal1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + " " + "-" + " " + toTitleCase(itm.salaryCurrency)  + " " + parseFloat(sal2).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          
          let _location = _dataList.filter(x=> x.companyCode===itm.companyId).length>0 ?
                          _dataList.find(x=> x.companyCode===itm.companyId).city: ""

          let noCapsLabelLoc = (_location).toLowerCase()
          let LocTmp = toTitleCase(noCapsLabelLoc)
          
          // let tmCompname = _dataList.filter(x=> x.userId===itm.companyId).length>0 ?
          //                   _dataList.find(x=> x.userId===itm.companyId).companyName: ""
          // let noCapsLabel = (tmCompname).toLowerCase()
          // let compName = toTitleCase(noCapsLabel)

          dataListTmp.push({

            companyName : itm.companyName,
            location : _location,
            companyId : itm.companyId,
            createdBy : itm.createdBy,
            createdDate : itm.createdDate,
            description : itm.Urgency,
            endDate : itm.endDate,
            experienceMax : itm.experienceMax,
            experienceMin : itm.experienceMin,
            id : itm.id,
            isClosed : itm.isClosed,
            isDeleted : itm.isDeleted,
            isPosted : itm.isPosted,
            keyWords : itm.keyWords,
            level : itm.level,
            postingId : itm.postingId,
            qualifications : itm.qualifications,
            responsibility : itm.responsibility,
            salaryBasis : itm.salaryBasis,
            salaryCurrency : itm.salaryCurrency,
            salaryMax : itm.salaryMax,
            salaryMin : itm.salaryMin,
            skillsExperience : itm.skillsExperience,
            startDate : itm.startDate,
            timeStamp : itm.timeStamp,
            title : itm.title,
            workType : itm.workType,
            urgency : itm.Urgency,
            updatedBy : itm.updatedBy,
            industry : itm.industry,
            updatedDate : itm.updatedDate,
            exp : expTmp,
            salaryRange : _salaryRangeTmp,
            notes : itm.jobPostingNote,
            workLocation : itm.workLocation,
            jobDepartment : itm.jobDepartment,

          })

        })

      }

      // // console.log(dataListTmp)

      setJobVacancy(dataListTmp.sort((a, b) => a.id < b.id ? 1 : -1))
      setStoreJson(dataListTmp.sort((a, b) => a.id < b.id ? 1 : -1))

      let locDistnct = dataListTmp.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.workLocation === thing.workLocation
      )))
      setJobVacancyDDL(locDistnct.sort((a, b) => a.id < b.id ? 1 : -1))

      let compNameDistnct = dataListTmp.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.companyName === thing.companyName
      )))
      console.log("compNameDistnct")
      console.log(compNameDistnct)
      setCompNameDDL(compNameDistnct.filter(x=> typeof x.companyName !== "undefined").sort((a, b) => a.id < b.id ? 1 : -1))

      let jobTypeDistnct = dataListTmp.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.industry === thing.industry
      )))
      setJobTypeDDL(jobTypeDistnct.sort((a, b) => a.id < b.id ? 1 : -1))

      let jobDept = dataListTmp.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          t.title === thing.title
      )))
      setJobDeptDDL(jobDept.sort((a, b) => a.id < b.id ? 1 : -1))


    }
    catch(error){
      
      // setMessage(error.message)
      console.log("error: " + error.message)

    }
  };

  function toTitleCase(str) {

    const titleCase = str
      .toLowerCase()
      .split(' ')
      .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  
    return titleCase;

  }

  function handleNavigate(key) {

    // alert("test")
    // // // // console.log("validate")
    // // // // console.log(validate)

    if(validate==="1"){

      // // // console.log("if")
      sessionStorage.setItem("key", JSON.stringify(key.postingId))
      navigateEmployer("/JobDescEmployer");

    }
    else {

      // // // console.log("else")
      sessionStorage.setItem("key", JSON.stringify(key.postingId))
      navigate("/JobDetailsDescription");

    }

  };

  function handleNavigateApplication(itms) {

    sessionStorage.setItem("key", JSON.stringify(itms.postingId))
    sessionStorage.setItem("companyId", JSON.stringify(itms.companyId))
    navigateApp("/ApplicationPage");
      
    // GetCompanyProfile()
  };

  const onChangeCompName = (e, value) =>{

    if(e.length === 0){
      setCompName("")
    }
    else{
      setCompName(e[0].companyName)
    }
    

  }

  const onChangeLocation = (e, value) =>{

    if(e.length === 0){
      setLocation("")
    }
    else{
      setLocation(e[0].workLocation)
    }
    

  }

  const onChangeJobClass = (e, value) =>{

    if(e.length === 0){
      setJobClass("")
    }
    else{
      setJobClass(e[0].industry)
    }
    

  }

  const onChangePosition = (e, value) =>{

    if(e.length === 0){
      setPosition("")
    }
    else{
      setPosition(e[0].title)
    }
    

  }

  

  function toTitleCase(str) {
    const titleCase = str
      .toLowerCase()
      .split(' ')
      .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  
    return titleCase;
  }

  // Search Function 


  

  const handleSearchFilter = async() => {

    // setisLoading(true)

    let _fdata = helperBuildCriteria()
    let _filterData = _fdata.split(",")
    let _objfd = {}

    let jsonData = {};
    for (let i = 0; i < _filterData.length - 1; i++) {

      let columnName = _filterData[i].split(":")[0]
      _objfd[columnName] = _filterData[i].split(":")[1];

    }
    ////////////// // // console.log("filter_data")
    ////////////// // // console.log(_objfd)

    GetFilterResult(_objfd);
  }

  

  const helperBuildCriteria = () => {

    let _filterData = {}
    let compname = ""
    let loc = ""
    let title = ""
    let pos = ""

    // // console.log("srchCompName")
    // // console.log(srchCompName)
// 
    if ( srchCompName != "" || srchCompName!== "" ) {

      compname = "companyName" + ":" + srchCompName + ","

    }

    if ( srchLocation != "" || srchLocation!== "" ) {

      loc = "workLocation" + ":" + srchLocation + ","

    }

    if ( srchJobClass != "" || srchJobClass!== "" ) {

      title = "industry" + ":" + srchJobClass + ","

    }

    if ( srchPosition != "" || srchPosition!== "" ) {

      pos = "title" + ":" + srchPosition + ","

    }

    _filterData = /* "isDeleted" + ":" + "0," + */ compname + loc + title + pos //+ _podate + _costcenter + _receiptdescription + _ponumber + _company
   
    return _filterData
    
  }

  const GetFilterResult = async(_objfd) => {

    // // console.log("_objfd")
    // // console.log(_objfd)


    try{

      let tempArr = []
    
      let resp = await GetRequest({

        url : AppConfiguration.Setting().jobspaceapi + "action/get",
        params : {

          "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
          "_collection" : "JobPosting",
          "filter_data" : _objfd

        }

      })

      // // console.log("resp")
      // // console.log(resp)

      if(resp.status==="1"){
        
        let dataX = []

        resp.JobPosting.forEach((itm,idx)=> {
          // compProfile
          let expTmp = itm.experienceMin + " " + "-" + " " + itm.experienceMax
          
          let _salaryRangeTmp = toTitleCase(itm.salaryCurrency) + " " + itm.salaryMin + " " + "-" + " " + toTitleCase(itm.salaryCurrency)  + " " + itm.salaryMax
          
          let _location = compProfile.filter(x=> x.userId===itm.companyId).length>0 ?
                          compProfile.find(x=> x.userId===itm.companyId).city: ""
          
          let noCapsLabelLoc = (_location).toLowerCase()
          
          let LocTmp = toTitleCase(noCapsLabelLoc)
          
          let tmCompname = compProfile.filter(x=> x.userId===itm.companyId).length>0 ?
                            compProfile.find(x=> x.userId===itm.companyId).companyName: ""
          
          let noCapsLabel = (tmCompname).toLowerCase()

          let compName = toTitleCase(noCapsLabel)


          dataX.push({

            companyName : itm.companyName,
            location : LocTmp,
            companyId : itm.companyId,
            createdBy : itm.createdBy,
            createdDate : itm.createdDate,
            description : itm.Urgency,
            endDate : itm.endDate,
            experienceMax : itm.experienceMax,
            experienceMin : itm.experienceMin,
            id : itm.id,
            isClosed : itm.isClosed,
            isDeleted : itm.isDeleted,
            isPosted : itm.isPosted,
            keyWords : itm.keyWords,
            level : itm.level,
            postingId : itm.postingId,
            qualifications : itm.qualifications,
            responsibility : itm.responsibility,
            salaryBasis : itm.salaryBasis,
            salaryCurrency : itm.salaryCurrency,
            salaryMax : itm.salaryMax,
            salaryMin : itm.salaryMin,
            skillsExperience : itm.skillsExperience,
            startDate : itm.startDate,
            timeStamp : itm.timeStamp,
            title : itm.title,
            workType : itm.workType,
            urgency : itm.Urgency,
            industry : itm.industry,
            updatedBy : itm.updatedBy,
            updatedDate : itm.updatedDate,
            exp : expTmp,
            salaryRange : _salaryRangeTmp,
            notes : itm.jobPostingNote,
            workLocation : itm.workLocation,

          })

        })

        // // // console.log(dataX)

        setJobVacancy(dataX.sort((a, b) => a.id < b.id ? 1 : -1))

      }

    }
    catch(error){
      // setMessage(error.message)
      // // console.log("error: " + error.message)
    }

  }

  const onClickClear = (e) =>{

    alert("qwet")
  }

  return (
    <React.Fragment>
      
      <div className="job-search-page">
        <Container fluid className="custom-container">

          <div className="text-center mb-4" style={{ color: "#088B1E" }}>
            <h1 className="display-6 fw-semibold mb-3">
              Search Between More Than{" "}
              <span className="fw-bold" style={{ color: "#A6AB14" }}>10,000+ </span>
              Available Jobs.
            </h1>
            <p className="fs-17">
              Find jobs, create traceable resumes and enrich your applications.
            </p>
          </div>

          <Form action="#" onSubmit={(e)=> e.preventDefault()} className="job-search-bar">
            <div className="registration-form">
              <Row className="g-2 align-items-center">
                <Col lg={3}>
                  <div className="filter-search-form mt-3 mt-lg-0">
                    {/* <i className="mdi mdi-search-web" style={{ color: "grey"}}></i> */}
                    
                    {/* <Input
                      type="search"
                      id="job-title"
                      className="form-control filter-input-box"
                      placeholder="Job, Company Name"
                      style={{backgroundColor: "#e7e7e7", color: "#000000"}}
                      onChange={onChangeCompName}
                    /> */}
                      
                      
                    {/* <select
                      name="companyName"
                      className="form-control filter-input-box"
                      style={{width : "300px", backgroundColor: "#e7e7e7"}}
                      // value={row.itemCode}
                      // disabled = {row.taxType === "" ? true : false}
                      onChange={(e) => onChangeCompName(e, e.target.value)} 
                      >
                      <option>Select Company Name</option>
                        {compNameDDL.filter(x=> x.companyName !== "").map((itm, idx) => (
                          <option key={idx} value={itm.companyName}>{itm.companyName}</option>
                        ))
                      }
                    </select> */}

                    

                    
                    <Typeahead
                      clearButton // = { (e) => onClickClear(e)}
                      labelKey="companyName"
                      id="search-company"
                      onChange={(e) => onChangeCompName(e)}
                      options={compNameDDL}
                      // selected={[getDocumentStatusValue]}
                      //options={getDataSelection.filter(x => x.labelId === containsWhitespace(item.fieldName) === true ? removeWhitespace(item.fieldName).toLowerCase() : item.fieldName.toLowerCase() )}
                      placeholder={"Select Company"}
                    />
                    

                  </div>
                </Col>
                <Col lg={2}>
                  <div className="filter-search-form mt-3 mt-lg-0">
                    <Typeahead
                      clearButton
                      labelKey="workLocation"
                      id="search-location"
                      onChange={(e) => onChangeLocation(e)}
                      options={jobVacancyDDL}
                      // selected={[getDocumentStatusValue]}
                      //options={getDataSelection.filter(x => x.labelId === containsWhitespace(item.fieldName) === true ? removeWhitespace(item.fieldName).toLowerCase() : item.fieldName.toLowerCase() )}
                      placeholder={"Select Location"}
                    />
                  </div>
                </Col>
                <Col lg={2}>
                  <div className="filter-search-form mt-3 mt-lg-0">
                    {/* <i className="uil uil-clipboard-notes" style={{ color: "grey"}}></i> */}
                    
                    {/* <Input
                      type="search"
                      id="job-title"
                      className="form-control filter-input-box"
                      placeholder="Job Type, Classification"
                      style={{backgroundColor: "#e7e7e7", color: "#000000"}}
                      onChange={onChangeJobClass}
                    /> */}

                    {/* <select
                      name="industry"
                      className="form-control filter-input-box"
                      style={{width : "300px", backgroundColor: "#e7e7e7"}}
                      // value={row.itemCode}
                      // disabled = {row.taxType === "" ? true : false}
                      onChange={(e) => onChangeJobClass(e, e.target.value)} 
                      >
                      <option >Select Classification</option>
                        {jobTypeDDL.filter(x=> x.industry !== "").map((itm, idx) => (
                          <option style={{fontWeight: "bold"}} key={idx} value={itm.industry}>{itm.industry}</option>
                        ))
                      }
                    </select> */}

                  
                  
                    <Typeahead
                      clearButton
                      labelKey="industry"
                      id="search-classification"
                      onChange={(e) => onChangeJobClass(e)}
                      options={jobTypeDDL}
                      // selected={[getDocumentStatusValue]}
                      //options={getDataSelection.filter(x => x.labelId === containsWhitespace(item.fieldName) === true ? removeWhitespace(item.fieldName).toLowerCase() : item.fieldName.toLowerCase() )}
                      placeholder={"Select Classification"}
                    />

                    {/* <select
                      className="form-control" 
                      id="nameControlInput" 
                      placeholder="Employment Type" 
                      style={{ borderStyle: "outset"}}
                      onChange={ e => handleChangeEmploymentType(e)}
                    >
                      {empJobType.map((resp) => (
                        <option key={resp.id} value={resp.department}>
                          {resp.department}
                        </option>
                      ))}
                    </select> */}
                  </div>
                </Col>
                <Col lg={2}>
                  <div className="filter-search-form mt-3 mt-lg-0">
                    {/* <i className="uil uil-map-marker" style={{ color: "grey"}}></i> */}
                      <Typeahead
                        clearButton
                        labelKey="title"
                        id="search-position"
                        onChange={(e) => onChangePosition(e)}
                        options={jobDept}
                        // selected={[getDocumentStatusValue]}
                        //options={getDataSelection.filter(x => x.labelId === containsWhitespace(item.fieldName) === true ? removeWhitespace(item.fieldName).toLowerCase() : item.fieldName.toLowerCase() )}
                        placeholder={"Select Position"}
                      />
                  </div>
                </Col>
                <Col lg={2} className="ms-lg-auto">
                  <div className=" mt-3 mt-lg-0 h-100">
                    <button
                      className="btn btn-success submit-btn w-100"
                      type="submit"
                      onClick={handleSearchFilter}
                    >
                      <i className="uil uil-search me-1"></i>
                      Find Jobs
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </Form>

          <div className="job-search-trending mt-2 mb-1">
            <ul className="list-inline mb-0 fs-14">
              <li className="list-inline-item text-muted">Trending:</li>
              <li className="list-inline-item"><Link to="#">Design</Link></li>
              <li className="list-inline-item"><Link to="#">Development</Link></li>
              <li className="list-inline-item"><Link to="#">Manager</Link></li>
              <li className="list-inline-item"><Link to="#">Senior</Link></li>
            </ul>
          </div>

          <Row className="mt-3">
            {/* LEFT: results list */}
            <Col lg={5}>
              <p className="job-results-count fs-14 mb-2">
                {jobVacancy.length} job{jobVacancy.length === 1 ? "" : "s"} found
              </p>
              <div className="job-results-list">
                {jobVacancy.length === 0 ? (
                  <div className="text-muted fs-14 py-4 text-center">No jobs found.</div>
                ) : (
                  jobVacancy.map((jobVacancyDetails, key) => {
                    const isActive =
                      selectedJob && selectedJob.postingId === jobVacancyDetails.postingId;
                    return (
                      <div
                        key={key}
                        role="button"
                        tabIndex={0}
                        aria-pressed={isActive}
                        className={"js-result-card" + (isActive ? " active" : "")}
                        onClick={() => setSelectedJob(jobVacancyDetails)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            setSelectedJob(jobVacancyDetails);
                          }
                        }}
                      >
                        <div className="d-flex">
                          <div className="js-logo me-3">
                            <i className="mdi mdi-office-building-outline" aria-hidden="true"></i>
                          </div>
                          <div className="flex-grow-1">
                            <h5 className="js-result-title fs-17 fw-semibold mb-1">
                              {jobVacancyDetails.title}
                            </h5>
                            <p className="text-muted fs-14 mb-2">
                              {jobVacancyDetails.companyName}
                            </p>
                            <ul className="list-inline mb-2 fs-13 text-muted">
                              <li className="list-inline-item">
                                <i className="mdi mdi-map-marker" aria-hidden="true"></i>{" "}
                                {jobVacancyDetails.workLocation}
                              </li>
                              <li className="list-inline-item">
                                <i className="uil uil-wallet" aria-hidden="true"></i>{" "}
                                {jobVacancyDetails.salaryRange}
                              </li>
                            </ul>
                            <div>
                              {jobVacancyDetails.workType ? (
                                <span className="badge bg-success-subtle text-success fs-13 me-1">
                                  {jobVacancyDetails.workType}
                                </span>
                              ) : null}
                              {jobVacancyDetails.urgency ? (
                                <span className="badge bg-warning-subtle text-warning fs-13">
                                  {jobVacancyDetails.urgency}
                                </span>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </Col>

            {/* RIGHT: detail pane */}
            <Col lg={7}>
              {selectedJob ? (
                <div className="job-detail-pane">
                  <div className="d-flex align-items-start mb-3">
                    <div className="js-logo me-3">
                      <i className="mdi mdi-office-building-outline" aria-hidden="true"></i>
                    </div>
                    <div className="flex-grow-1">
                      <h3 className="fs-22 fw-bold mb-1 text-dark">{selectedJob.title}</h3>
                      <p className="fs-16 mb-2 text-dark">{selectedJob.companyName}</p>
                      <ul className="list-inline fs-14 text-muted mb-0">
                        <li className="list-inline-item">
                          <i className="mdi mdi-map-marker" aria-hidden="true"></i>{" "}
                          {selectedJob.workLocation}
                        </li>
                        <li className="list-inline-item">
                          <i className="uil uil-wallet" aria-hidden="true"></i>{" "}
                          {selectedJob.salaryRange}
                        </li>
                        {selectedJob.createdDate ? (
                          <li className="list-inline-item">
                            <i className="uil uil-clock" aria-hidden="true"></i>{" "}
                            {selectedJob.createdDate}
                          </li>
                        ) : null}
                      </ul>
                    </div>
                  </div>

                  <div className="mb-3">
                    {selectedJob.workType ? (
                      <span className="badge bg-success-subtle text-success fs-13 me-1">
                        {selectedJob.workType}
                      </span>
                    ) : null}
                    {selectedJob.urgency ? (
                      <span className="badge bg-warning-subtle text-warning fs-13 me-1">
                        {selectedJob.urgency}
                      </span>
                    ) : null}
                    {selectedJob.industry ? (
                      <span className="badge bg-primary-subtle text-primary fs-13">
                        {selectedJob.industry}
                      </span>
                    ) : null}
                  </div>

                  {validate === "1" ? null : (
                    <button
                      className="btn btn-success"
                      onClick={() => handleNavigateApplication(selectedJob)}
                    >
                      Apply Now{" "}
                      <i className="mdi mdi-chevron-double-right" aria-hidden="true"></i>
                    </button>
                  )}

                  <hr />

                  <h6 className="fw-semibold mb-3">Job Overview</h6>
                  <div className="job-detail-overview">
                    <div>
                      <div className="label">Industry</div>
                      <div className="value">{selectedJob.industry || "—"}</div>
                    </div>
                    <div>
                      <div className="label">Department</div>
                      <div className="value">{selectedJob.jobDepartment || "—"}</div>
                    </div>
                    <div>
                      <div className="label">Experience</div>
                      <div className="value">{selectedJob.exp || "—"}</div>
                    </div>
                    <div>
                      <div className="label">Level</div>
                      <div className="value">{selectedJob.level || "—"}</div>
                    </div>
                    <div>
                      <div className="label">Salary Basis</div>
                      <div className="value">{selectedJob.salaryBasis || "—"}</div>
                    </div>
                    <div>
                      <div className="label">Offered Salary</div>
                      <div className="value">{selectedJob.salaryRange || "—"}</div>
                    </div>
                  </div>

                  {selectedJob.notes ? (
                    <div className="job-detail-section">
                      <h6>Notes</h6>
                      <p className="fs-14 text-dark mb-0" style={{ textAlign: "justify" }}>
                        {selectedJob.notes}
                      </p>
                    </div>
                  ) : null}

                  {Array.isArray(selectedJob.responsibility) &&
                  selectedJob.responsibility.length > 0 ? (
                    <div className="job-detail-section">
                      <h6>Responsibilities</h6>
                      <ul className="fs-14">
                        {selectedJob.responsibility.map((itm, i) => {
                          const t = itemText(itm, ["responsibility"]);
                          return t ? <li key={i}>{t}</li> : null;
                        })}
                      </ul>
                    </div>
                  ) : null}

                  {Array.isArray(selectedJob.skillsExperience) &&
                  selectedJob.skillsExperience.length > 0 ? (
                    <div className="job-detail-section">
                      <h6>Skills Required</h6>
                      <ul className="fs-14">
                        {selectedJob.skillsExperience.map((itm, i) => {
                          const t = itemText(itm, ["skill"]);
                          return t ? <li key={i}>{t}</li> : null;
                        })}
                      </ul>
                    </div>
                  ) : null}

                  {Array.isArray(selectedJob.qualifications) &&
                  selectedJob.qualifications.length > 0 ? (
                    <div className="job-detail-section">
                      <h6>Qualifications</h6>
                      <ul className="fs-14">
                        {selectedJob.qualifications.map((itm, i) => {
                          const t = itemText(itm, ["qualification", "qualifications", "name"]);
                          return t ? <li key={i}>{t}</li> : null;
                        })}
                      </ul>
                    </div>
                  ) : typeof selectedJob.qualifications === "string" &&
                    selectedJob.qualifications ? (
                    <div className="job-detail-section">
                      <h6>Qualifications</h6>
                      <p className="fs-14 text-dark mb-0">{selectedJob.qualifications}</p>
                    </div>
                  ) : null}
                </div>
              ) : (
                <div className="job-detail-pane">
                  <div className="job-detail-empty">
                    <i className="uil uil-file-search-alt d-block mb-2 fs-1" aria-hidden="true"></i>
                    Select a job to see the details
                  </div>
                </div>
              )}
            </Col>
          </Row>

          <div
            className="modal fade"
            id="applyNow"
            tabIndex="-1"
            aria-labelledby="applyNow"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <Modal isOpen={modal} toggle={openModal} centered>
                <ModalBody className="modal-body p-5">
                  <div className="text-center mb-4">
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Apply For This Job
                    </h5>
                  </div>
                  <div className="position-absolute end-0 top-0 p-3">
                    <button
                      type="button"
                      onClick={openModal}
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="mb-3">
                    <Label for="nameControlInput" className="form-label">
                      Name
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="nameControlInput"
                      placeholder="Enter your name"
                    />
                  </div>
                  <div className="mb-3">
                    <Label for="emailControlInput2" className="form-label">
                      Email Address
                    </Label>
                    <Input
                      type="email"
                      className="form-control"
                      id="emailControlInput2"
                      placeholder="Enter your email"
                    />
                  </div>
                  <div className="mb-3">
                    <Label for="messageControlTextarea" className="form-label">
                      Message
                    </Label>
                    <textarea
                      className="form-control"
                      id="messageControlTextarea"
                      rows="4"
                      placeholder="Enter your message"
                    ></textarea>
                  </div>
                  <div className="mb-4">
                    <Label className="form-label" for="inputGroupFile01">
                      Resume Upload
                    </Label>
                    <Input
                      type="file"
                      className="form-control"
                      id="inputGroupFile01"
                    />
                  </div>
                  <button type="submit" className="btn btn-success w-100">
                    Send Application
                  </button>
                </ModalBody>
              </Modal>
            </div>
          </div>

        </Container>
      </div>

    </React.Fragment>
  );
};

export default JobVacancy;